import { render, staticRenderFns } from "./ClaimsPopup.vue?vue&type=template&id=9c3d543a&scoped=true"
import script from "./ClaimsPopup.vue?vue&type=script&lang=ts"
export * from "./ClaimsPopup.vue?vue&type=script&lang=ts"
import style0 from "./ClaimsPopup.vue?vue&type=style&index=0&id=9c3d543a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c3d543a",
  null
  
)

export default component.exports